import type { InvivoSceneMaterialDefinition } from "../types/invivo_scene";

interface MaterialStylePreset {
  baseColor: string;
  alpha?: number;
  metallic: number;
  roughness: number;
  backFaceCulling?: boolean;
}

export function buildLegacyStylePreset(materialName: string): MaterialStylePreset {
  switch (materialName.toLowerCase()) {
    case "bon":
      return { baseColor: "#afada0", metallic: 0, roughness: 111 / 256 };
    case "mus":
      return { baseColor: "#874f4c", metallic: 0, roughness: 121 / 256 };
    case "lig":
      return { baseColor: "#c6b0a7", metallic: 0, roughness: 97 / 256 };
    case "fas":
      return { baseColor: "#c8b9aa", metallic: 0, roughness: 0.95, alpha: 0.7 };
    case "skin":
      return { baseColor: "#c99080", metallic: 0, roughness: 220 / 256, backFaceCulling: false };
    case "ner":
      return { baseColor: "#e0c43d", metallic: 0, roughness: 0.55, alpha: 1, backFaceCulling: false };
    case "art":
      return { baseColor: "#bb1f1f", metallic: 0, roughness: 0.45, alpha: 1, backFaceCulling: false };
    case "vei":
      return { baseColor: "#464170", metallic: 0, roughness: 0.45, alpha: 1, backFaceCulling: false };
    case "eyebrows":
      return { baseColor: "#221a16", metallic: 0, roughness: 0.8, alpha: 1, backFaceCulling: false };
    case "eyelashes":
      return { baseColor: "#221a16", metallic: 0, roughness: 0.8, alpha: 1, backFaceCulling: false };
    case "wrapping":
      return { baseColor: "#4568a8", metallic: 0.08, roughness: 0.88, alpha: 0.92, backFaceCulling: false };
    case "sheet":
      return { baseColor: "#5b7bb5", metallic: 0.08, roughness: 0.88, alpha: 0.9, backFaceCulling: false };
    case "legwraps":
      return { baseColor: "#4568a8", metallic: 0.08, roughness: 0.88, alpha: 0.92, backFaceCulling: false };
    default:
      return { baseColor: "#b8bcc3", metallic: 0.2, roughness: 0.7 };
  }
}

export function builtinLegacyMaterialDefinition(materialName: string): InvivoSceneMaterialDefinition | null {
  switch (materialName.toLowerCase()) {
    case "ner":
      return {
        program: "ner_material.json",
        baseColor: "#e0c43d",
        backfaces: true,
      };
    case "eyebrows":
      return {
        program: "hair_material.json",
        baseColor: "#221a16",
        backfaces: true,
      };
    case "eyelashes":
      return {
        program: "hair_material.json",
        baseColor: "#221a16",
        backfaces: true,
      };
    case "sheet":
      return {
        program: "sheet_material.json",
        preview: {
          filename: "shared/sheets/Sheets_PreviewTile.png",
          invert_y: true,
          u_scale: 300,
          v_scale: 300,
        },
        AlbedoRoughness: {
          filename: "shared/sheets/Sheets_AlbedoRoughness.png",
          invert_y: true,
        },
        XYCA: "Sheets_XYCA.png",
        Dots: {
          filename: "shared/sheets/Sheets_Dots_XYRA.png",
          invert_y: true,
        },
        Crumples: {
          filename: "shared/sheets/Sheets_Crumples_XYRA.png",
          invert_y: true,
        },
        Creases: {
          filename: "shared/sheets/Sheets_Creases_XYRA.png",
          invert_y: true,
        },
        Fibers: {
          filename: "shared/sheets/Sheets_Fibers_XYRA.png",
          invert_y: true,
        },
        backfaces: true,
      };
    default:
      return null;
  }
}
